import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    backgroundColor: theme.palette.grey[900],
    opacity: 0.85,
  },
}));

export default function DarkenBackground(props) {
  const classes = useStyles(props);
  return <div className={classes.root} />;
}
